module.exports = __webpack_public_path__ + "img/SE5565002762.f947d6f9.png";